{
  "familyId": "MET-SYMMETRIE",
  "questions": [
    {
      "id": "MET-SYMMETRIE-001",
      "familyId": "MET-SYMMETRIE",
      "module": "Metriek",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "figuren",
      "subSkill": "symmetrie_spiegeling",
      "questionType": "multiple_choice",
      "question": "Hoeveel spiegelassen heeft een vierkant?",
      "context": null,
      "options": ["4", "2", "1", "8"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "symmetryGrid",
          "data": {
            "rows": 6,
            "cols": 6,
            "shadedCells": [0, 1, 2, 6, 7, 8, 12, 13, 14],
            "axis": "vertical",
            "showMirror": true,
            "label": "Vierkant met verticale spiegelas (let op: een vierkant heeft er in totaal 4 — 2 door de zijden + 2 diagonaal)"
          }
        }
      ],
      "supportAids": [],
      "conceptId": "symmetrie_vierkant",
      "variantIndex": 1,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.73,
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "met.symmetrie-lijnen-aantal", "label": "2 klopt voor een rechthoek, niet voor een vierkant", "optionIndex": 1 },
          { "id": "met.symmetrie-lijnen-aantal", "label": "1 klopt voor een gelijkbenige driehoek, niet voor een vierkant", "optionIndex": 2 },
          { "id": "met.symmetrie-lijnen-aantal", "label": "8 is te veel — een vierkant heeft precies 4", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Een vierkant heeft 4 spiegelassen: 2 door de middens van de zijden (1 horizontaal + 1 verticaal) en 2 diagonaal door de hoeken. Veel kinderen vergeten de diagonale assen — let er op! Elke spiegelas verdeelt het vierkant in twee gelijke spiegelhelften.",
        "solutionSteps": [
          "Spiegelas = lijn die de figuur in twee spiegelhelften verdeelt",
          "Vierkant: 1 horizontale spiegelas door midden zijden",
          "Vierkant: 1 verticale spiegelas door midden zijden",
          "Vierkant: 2 diagonale spiegelassen door de hoeken",
          "Totaal: 4 spiegelassen"
        ],
        "distractorExplanations": {
          "0": "Goed! Een vierkant heeft 4 spiegelassen: 2 door de middens van de zijden en 2 diagonaal door de hoeken.",
          "1": "2 klopt voor een rechthoek (die geen vierkant is). Een vierkant heeft er 4: vergeet de twee diagonale spiegelassen niet.",
          "2": "1 spiegelas klopt voor een gelijkbenige driehoek, maar een vierkant heeft er 4.",
          "3": "8 is te veel. Een vierkant heeft precies 4 spiegelassen."
        }
      }
    },
    {
      "id": "MET-SYMMETRIE-002",
      "familyId": "MET-SYMMETRIE",
      "module": "Metriek",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "figuren",
      "subSkill": "symmetrie_spiegeling",
      "questionType": "multiple_choice",
      "question": "Welke hoofdletter heeft GEEN spiegelas?",
      "context": null,
      "options": ["H", "A", "F", "M"],
      "correctAnswer": 2,
      "stimulusAids": [
        {
          "type": "symmetryGrid",
          "data": {
            "rows": 5,
            "cols": 5,
            "shadedCells": [0, 5, 10, 11, 15, 16],
            "axis": "vertical",
            "showMirror": false,
            "label": "Letter F — geen spiegelas"
          }
        }
      ],
      "supportAids": [],
      "conceptId": "symmetrie_letters",
      "variantIndex": 2,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.70,
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "met.symmetrie-lijnen-aantal", "label": "H heeft zelfs twee spiegelassen", "optionIndex": 0 },
          { "id": "met.symmetrie-lijnen-aantal", "label": "A heeft een verticale spiegelas", "optionIndex": 1 },
          { "id": "met.symmetrie-lijnen-aantal", "label": "M heeft een verticale spiegelas", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "De letter F heeft geen spiegelas. Als je de F verticaal of horizontaal vouwt, passen de helften niet op elkaar. A heeft een verticale spiegelas, H heeft er twee (verticaal en horizontaal), en M heeft een verticale.",
        "solutionSteps": [
          "A: verticale spiegelas ✓",
          "H: verticale én horizontale spiegelas ✓",
          "M: verticale spiegelas ✓",
          "F: geen spiegelas (helften passen niet op elkaar)"
        ],
        "distractorExplanations": {
          "0": "H heeft zelfs twee spiegelassen: verticaal en horizontaal.",
          "1": "A heeft wél een verticale spiegelas: de linker- en rechterhelft zijn elkaars spiegelbeeld.",
          "2": "Goed! De letter F heeft geen spiegelas.",
          "3": "M heeft een verticale spiegelas: de linker- en rechterhelft zijn elkaars spiegelbeeld."
        }
      }
    },
    {
      "id": "MET-SYMMETRIE-003",
      "familyId": "MET-SYMMETRIE",
      "module": "Metriek",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "figuren",
      "subSkill": "symmetrie_spiegeling",
      "questionType": "multiple_choice",
      "question": "Een gelijkzijdige driehoek heeft ... spiegelassen.",
      "context": null,
      "options": ["1", "3", "2", "6"],
      "correctAnswer": 1,
      "stimulusAids": [
        {
          "type": "symmetryGrid",
          "data": {
            "rows": 6,
            "cols": 6,
            "shadedCells": [2, 3, 7, 8, 9, 10, 13, 14, 15, 16, 17, 19, 20, 21, 22, 23],
            "axis": "vertical",
            "showMirror": true,
            "label": "Gelijkzijdige driehoek met verticale spiegelas (totaal 3 spiegelassen)"
          }
        }
      ],
      "supportAids": [],
      "conceptId": "symmetrie_driehoek",
      "variantIndex": 3,
      "citoDifficulty": 0.33,
      "citoDiscrimination": 0.74,
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "met.symmetrie-lijnen-aantal", "label": "1 klopt voor gelijkbenig, niet gelijkzijdig", "optionIndex": 0 },
          { "id": "met.symmetrie-lijnen-aantal", "label": "2 klopt niet voor een driehoek — het is 1 of 3", "optionIndex": 2 },
          { "id": "met.symmetrie-lijnen-aantal", "label": "6 is te veel — een gelijkzijdige driehoek heeft 3", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Een gelijkzijdige driehoek heeft 3 spiegelassen. Elke spiegelas loopt van een hoekpunt naar het midden van de tegenoverliggende zijde. Dat kan bij alle 3 de hoekpunten.",
        "solutionSteps": [
          "Gelijkzijdig = alle 3 zijden even lang",
          "Spiegelas: van hoekpunt → midden overliggende zijde",
          "3 hoekpunten → 3 spiegelassen"
        ],
        "distractorExplanations": {
          "0": "1 spiegelas klopt voor een gelijkbenige driehoek (2 zijden gelijk), maar een gelijkzijdige driehoek (3 zijden gelijk) heeft er 3.",
          "1": "Goed! Een gelijkzijdige driehoek heeft 3 spiegelassen.",
          "2": "2 spiegelassen klopt niet voor een driehoek. Het is 1 (gelijkbenig) of 3 (gelijkzijdig).",
          "3": "6 is te veel. Een gelijkzijdige driehoek heeft precies 3 spiegelassen."
        }
      }
    },
    {
      "id": "MET-SYMMETRIE-004",
      "familyId": "MET-SYMMETRIE",
      "module": "Metriek",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "figuren",
      "subSkill": "symmetrie_spiegeling",
      "questionType": "multiple_choice",
      "question": "Je spiegelt punt A(2, 3) in de verticale lijn x = 5. Wat zijn de coördinaten van het spiegelbeeld?",
      "context": null,
      "options": ["(−2, 3)", "(2, 7)", "(5, 3)", "(8, 3)"],
      "correctAnswer": 3,
      "stimulusAids": [
        {
          "type": "coordinateGrid",
          "data": {
            "xMin": 0,
            "xMax": 10,
            "yMin": 0,
            "yMax": 6,
            "points": [{"x": 2, "y": 3, "label": "A"}],
            "lines": [{"x": 5, "style": "dashed", "label": "spiegellijn"}]
          }
        }
      ],
      "supportAids": [
        {
          "type": "symmetryGrid",
          "showWhen": "wrong",
          "data": {
            "rows": 6,
            "cols": 10,
            "shadedCells": [12],
            "axis": "vertical",
            "showMirror": true,
            "label": "Spiegeling in x = 5"
          }
        }
      ],
      "conceptId": "symmetrie_spiegelen_coord",
      "variantIndex": 4,
      "citoDifficulty": 0.43,
      "citoDiscrimination": 0.68,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "met.symmetrie-spiegelas-fout", "label": "Spiegelt in y-as (x=0) i.p.v. x=5", "optionIndex": 0 },
          { "id": "met.symmetrie-spiegelas-fout", "label": "Verandert y i.p.v. x — verwart horizontale en verticale spiegeling", "optionIndex": 1 },
          { "id": "met.symmetrie-spiegelas-fout", "label": "Kiest het punt OP de spiegellijn, niet het spiegelbeeld", "optionIndex": 2 }
        ]
      },
      "feedback": {
        "explanationText": "Punt A(2, 3) ligt 3 eenheden links van de spiegellijn x = 5 (want 5 − 2 = 3). Het spiegelbeeld ligt 3 eenheden rechts van de lijn: 5 + 3 = 8. De y-coördinaat blijft 3. Dus: (8, 3).",
        "solutionSteps": [
          "Afstand van A tot spiegellijn: 5 − 2 = 3 eenheden",
          "Spiegelbeeld ligt 3 eenheden aan de andere kant: 5 + 3 = 8",
          "y-coördinaat verandert niet bij verticale spiegeling",
          "Spiegelbeeld: (8, 3)"
        ],
        "distractorExplanations": {
          "0": "(−2, 3) zou kloppen als je in de y-as (x = 0) spiegelt, maar de spiegellijn is x = 5.",
          "1": "(2, 7) zou kloppen als je in een horizontale lijn spiegelt, maar de spiegellijn is verticaal (x = 5). Dan verandert de x, niet de y.",
          "2": "(5, 3) is het punt OP de spiegellijn. Het spiegelbeeld ligt even ver aan de andere kant.",
          "3": "Goed! A(2, 3) gespiegeld in x = 5 geeft (8, 3)."
        }
      }
    },
    {
      "id": "MET-SYMMETRIE-005",
      "familyId": "MET-SYMMETRIE",
      "module": "Metriek",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "figuren",
      "subSkill": "symmetrie_spiegeling",
      "questionType": "fill_in",
      "question": "Een regelmatige zeshoek heeft ... spiegelassen. Typ het aantal.",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["6", "zes"],
        "caseSensitive": false,
        "placeholder": "..."
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "symmetryGrid",
          "showWhen": "wrong",
          "data": {
            "rows": 6,
            "cols": 6,
            "shadedCells": [2, 3, 7, 8, 9, 10, 12, 13, 14, 15, 16, 17, 19, 20, 21, 22, 26, 27],
            "axis": "vertical",
            "showMirror": true,
            "label": "Zeshoek met spiegelas"
          }
        }
      ],
      "conceptId": "symmetrie_zeshoek_fill",
      "variantIndex": 5,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.69,
      "pedagogy": {
        "dok": 1
      },
      "feedback": {
        "explanationText": "Een regelmatige zeshoek heeft 6 spiegelassen. Regel: een regelmatige veelhoek met n zijden heeft n spiegelassen. Zeshoek → 6 zijden → 6 spiegelassen.",
        "solutionSteps": [
          "Regel: regelmatige n-hoek → n spiegelassen",
          "Zeshoek = 6 zijden",
          "Dus: 6 spiegelassen"
        ]
      }
    }
  ]
}